var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.3,0c-3.3,0-6.6,0.5-9.7,1.5C44.3,45.6-31.5,193.1,12.5,330.4c44,137.3,191.6,213.1,328.9,169.1 c79.7-25.6,142.7-88.3,168.7-167.8c2.7-8.3,2-17.1-1.9-24.8c-3.9-7.7-10.6-13.5-18.9-16.2c-3.3-1.1-6.7-1.6-10.1-1.6h-0.9 c-13.4,0.4-25,9.1-29.1,21.9c-16.2,50.1-50.9,90.9-97.7,114.9c-46.8,24-100.2,28.3-150.3,12.1C151,421.7,110.2,387,86.2,340.2 c-24-46.8-28.3-100.2-12.1-150.3c19.3-59.7,66.4-107.1,126-126.7C213.8,58.7,223,46,223,31.6C223,14.2,208.8,0,191.3,0z M332.3,0.1 c-5,0-9.9,1.2-14.5,3.5c-7.6,3.9-13.2,10.5-15.8,18.6c-1,3.2-1.6,6.5-1.6,9.8c0,14.5,8.8,26.6,21.8,30.8l0,0 C382,82.3,429.4,129.6,449,189.4c4.4,13.3,16.7,22.3,30.7,22.3c0,0,0,0,0,0c18.1,0,32.3-14.2,32.3-31.5c0-3.3-0.5-6.6-1.5-9.7 C484.7,90.7,421.8,27.6,342.2,1.7C338.9,0.6,335.6,0.1,332.3,0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.7cab0be4d0569ab46876bc092ce7e73e.svg";
export { ForwardRef as ReactComponent };